module.exports = {"amp":"&","apos":"'","gt":">","lt":"<","quot":"\""}


//////////////////
// WEBPACK FOOTER
// ../dom-serializer/node_modules/entities/lib/maps/xml.json
// module id = 144
// module chunks = 0 2